import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';

export default class IssuerInvestmentPagedLookupCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Nullable()
    public issuerId: number | null = null;

    @Attributes.Nullable()
    @Attributes.Integer()
    public issuerInvestmentId: number | null = null;

    @Attributes.Nullable()
    public entityId: number | null = null;

    @Attributes.Nullable()
    public productTypeId: number | null = null;
    
    public showUnauthorised: boolean = false;

    public showInactive: boolean = false;

    public issuerName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Issuer Investment Paged Lookup Criteria";
    }
}